
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum AccountingPlanStatus {
	None = 0,
	Control = 1
}
export namespace AccountingPlanStatus {
	export function getKeys(): Map<AccountingPlanStatus, string> {
		return new Map([[0, 'None'], [1, 'Control']]);
	}
}
